import { useEffect } from 'react';
import { useForm } from 'react-final-form';
import { IAutoCompleteItem } from '../../typings/autoComplete';

// Explicit request (create client / matter dialogs): when the enquiry only carries an organisation NAME, the dialog
// searches existing parties for it. It used to switch to the "select an existing organisation" dropdown as soon as
// the search returned anything at all (a loose "contains" search) - and left that dropdown empty. It now only
// switches when an existing organisation has exactly that name, and pre-selects it.

interface PartySummary {
    name: string;
    guidID: string | number;
}

const normalise = (value: string | null | undefined): string => (value || '').trim().toLowerCase();

export const findExactOrganisationMatch = (summaries: PartySummary[] | null | undefined, organisationName: string | null | undefined): IAutoCompleteItem | null => {
    const wanted = normalise(organisationName);
    if (!wanted || !summaries) {
        return null;
    }
    const match = summaries.find((summary) => normalise(summary.name) === wanted);
    return match ? { label: match.name, value: String(match.guidID) } as IAutoCompleteItem : null;
};

// Renders nothing. Must sit inside the <Form>: selects the matched organisation in the form once, unless the
// user (or the enquiry itself) already chose one.
export const ApplyMatchedOrganisation = ({ organisation }: { organisation: IAutoCompleteItem | null }) => {
    const form = useForm();

    useEffect(() => {
        if (organisation && form.getState().values.organisation === null) {
            form.change('organisation', organisation);
        }
    }, [organisation, form]);

    return null;
};
